import type { ProductsContextType, ProductsProviderProps } from './IProductsProvider';
import type { IProduct } from '~/modules/product';

import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { useFetchShopifyProducts, useProductStore } from '~/modules/product';
import { useProductSearch } from '~/modules/product/modules/search';

export const ProductsContext = createContext<ProductsContextType | undefined>(undefined);
export const ProductsProvider: React.FC<ProductsProviderProps> = ({ children }) => {
  const [selectedProduct, setSelectedProduct] = useState<IProduct[]>();
  const products = useProductStore((state) => state.products);

  const fetchProductState = useFetchShopifyProducts({});
  const productSearcher = useProductSearch({
    fetchProductState,
  });
  const handleSelectedProduct = useCallback(
    (product: IProduct[]) => setSelectedProduct(product),
    [],
  );

  const contextValue = useMemo(
    () => ({
      products,
      productSearcher,
      fetchProductState,
      selectedProduct,
      handleSelectedProduct,
    }),
    [fetchProductState, selectedProduct, productSearcher, products, handleSelectedProduct],
  );

  return <ProductsContext.Provider value={contextValue}>{children}</ProductsContext.Provider>;
};

export const useProductsContext = () => {
  const context = useContext(ProductsContext);

  if (!context) {
    throw new Error('useProductsContext must be used within ProductsProvider');
  }

  return context;
};
